<template>
    <x-page :title="pageTitle">
        <template #header-actions>
            <x-back-button :disabled="isLoading" :display-warning="false" />
        </template>
        <metric-category-form id="metric-category-form"
            v-if="resource"
            :disabled="true"
            :initialFields="resource" />
    </x-page>
</template>

<script>
import XBackButton from '../../components/XBackButton.vue'
import XPage from '../../components/XPage.vue'
import { handleGeneralXhrError } from '../../helpers'
import MetricCategoryForm from './MetricCategoryForm.vue'

export default {
    components: {
        XPage,
        XBackButton,
        MetricCategoryForm,
    },
    computed: {
        pageTitle() {
            return `Kategori Metric | ${this.resource?.name}`
        }
    },
    created() {
        this.fetchResource()
    },
    data() {
        return {
            errors: null,
            isLoading: false,
            resource: null,
        }
    },
    methods: {
        fetchResource() {
            this.isLoading = true
            const request = axios.get(`/api/metric-categories/${this.$route.params.id}`)
                .then(response => {
                    this.resource = response.data.data
                })
            return handleGeneralXhrError(request).finally(() => {
                this.isLoading = false
            })
        },
    },
}
</script>